(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('AddDisease', AddDisease);

    AddDisease.$inject = ['$resource'];

    function AddDisease ($resource) {
        var resourceUrl =  'api/add-diseases/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
